
import promoWidgetQuery from '@/apollo/queries/general/promoWidgetQuery';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';

export default {
  name: 'PromoFloatingWidget',
  mixins: [eventTrackingMixins],
  apollo: {
    $loadingKey: 'loading',
    promoWidget: {
      prefetch: true,
      query: promoWidgetQuery,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) }
      },
      update(data) {
        return this.$normalizeStrapi(data.promoWidgetItems);
      },
    },
  },

  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      closedPromoWidgets: [],
      currentItemIndex: {}, // Track the current index for each promo widget
    };
  },
  mounted() {
    this.initializeItemRotation();
  },
  watch: {
    '$route.fullPath': function () {
      this.initializeItemRotation();
    },
  },
  computed: {
    activePromoWidget() {
      return this.promoWidget?.filter((item) => {
        const cookiesKey = '10life-' + item?.Name.replace(/\s/g, '-');

        // Hide widget outside of the inner widget
        if ( this.type === 'inner' && item?.IsInnerWidget !== true) return false;
        if ( this.type !== 'inner' && item?.IsInnerWidget === true) return false;

        if (this.clickedClose(cookiesKey)) return false;
        if (this.closedPromoWidgets.includes(cookiesKey)) return false;
        return true
      });
    },
    //
  },
  methods: {
    clickedClose(cookiesKey) {
      if(process.client) {
        const value = sessionStorage.getItem(cookiesKey);
        if (value) {
          return true;
        }
      } else {
        return false;
      }
    },
    closeWidget(cookiesKey) {
      cookiesKey = cookiesKey.replace(/\s/g, '-');
      this.setSession(cookiesKey, true);
      if (!this.closedPromoWidgets.includes(cookiesKey)) {
        this.closedPromoWidgets.push(cookiesKey);
      }
    },
    setSession(key, value) {
      if (process.client) {
        const eventTrackingParams = this.initEventTrackingParams();

        // Retrieve the current item and its TrackingParams
        const currentWidget = this.activePromoWidget.find((item, index) => {
          const cookiesKey = '10life-' + item?.Name.replace(/\s/g, '-');
          return cookiesKey === key;
        });

        if (currentWidget) {
          const widgetIndex = this.activePromoWidget.indexOf(currentWidget);
          const currentIndex = this.currentItemIndex[widgetIndex] || 0;
          const currentItem = currentWidget?.Items?.[currentIndex];
          const trackingParams = currentItem?.TrackingParams;

          // Assign TrackingParams to targetItem
          const targetItem = trackingParams || {};

          eventTrackingParams.a = 'close_promo_widget';
          eventTrackingParams.l = targetItem.event_action;
          eventTrackingParams.c = 'promo_widget';
          this.sendEventTracking(eventTrackingParams);
        }

        // Store the session key
        sessionStorage.setItem(key, value);
      }
    },
    handleTracking(link, trackingParams) {
      const eventAction = trackingParams?.event_action;
      if (!eventAction) console.error('PromoFloatingWidget - eventAction:', eventAction);
      const eventCategory = this.type ===  'inner' ? 'inner_promo_widget' : 'promo_widget';

      const eventTrackingParams = this.initEventTrackingParams();
      const targetLink = link;

      eventTrackingParams.a = eventAction;
      eventTrackingParams.l = targetLink;
      eventTrackingParams.c = eventCategory;
      this.sendEventTracking(eventTrackingParams);

    },
    isBlogSinglePage() {
      if (this.$route.name) {
        return this.$route.name.split('___')[0] === 'blog-slug';
      }
      return false;
    },
    allowDisplay(displayRules) {
      const { allow_full_site, allow_blog_cat, disallow_blog_cat, disallow_url_text, allow_url_text } = displayRules;

      if (disallow_url_text.length > 0) {
        const disallow = disallow_url_text.some((item) => {
          // console.debug('fullPath & item.Text', encodeURIComponent(this.$route.fullPath).toLowerCase(), encodeURIComponent(item.Text).toLowerCase());
          return (encodeURIComponent(this.$route.fullPath).toLowerCase()).includes(encodeURIComponent(item.Text).toLowerCase());
        });
        if (disallow) return false;
      }
      if (disallow_blog_cat.length > 0) {
        if (this.isBlogSinglePage()) {
          const disallow = disallow_blog_cat.some((item) => {
            return this.$store.state.blog.currentBlogSingleTags.some((tag) => tag.TagCode === item.TagCode);
          });
          if (disallow) return false;
        }
      }

      if (allow_full_site) return true;
      if (allow_url_text.length > 0) {
        const allow = allow_url_text.some((item) => {
          // console.debug('fullPath & item.Text', encodeURIComponent(this.$route.fullPath).toLowerCase(), encodeURIComponent(item.Text).toLowerCase());
          return (encodeURIComponent(this.$route.fullPath).toLowerCase()).includes(encodeURIComponent(item.Text).toLowerCase());
        });
        if (allow) return true;
      }
      if (allow_blog_cat.length > 0) {
        if (this.isBlogSinglePage()) {
          const allow = allow_blog_cat.some((item) => {
            return this.$store.state.blog.currentBlogSingleTags.some((tag) => tag.TagCode === item.TagCode);
          });
          if (allow) return true;
        }
      }

      return false;
    },
    getCurrentItemIndex(item, index) {
      // Return the current index for the widget
      return this.currentItemIndex[index] || 0;
    },
    initializeItemRotation() {
      // Ensure activePromoWidget is populated before setting indices
      if (!this.activePromoWidget || this.activePromoWidget.length === 0) return;

      this.activePromoWidget.forEach((item, index) => {
        const itemCount = item?.Items?.length || 0;
        if (itemCount > 0) {
          // Set the initial index for each widget
          this.$set(
            this.currentItemIndex,
            index,
            Math.floor(Math.random() * itemCount) // Randomize the initial index
          );
        }
      });
    },
  },
};
